import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getHomeProductStart,
  getHomeProductSuccess,
  getHomeProductFailure,
} from "../reducers/getHomeProductReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const getHomeProduct = createAsyncThunk(
  "getHomeProduct",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(getHomeProductStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Home/GetHomeProduct`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getHomeProductSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getHomeProductFailure(error.response.data.Message));
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
